/**
 * convert digit English standard  inside the text
 * to farsi(Persian standard keyboard) for show in UI
 * @param {string} value - this is text for search and replace digit
 * @returns {string} hello 124 => hello ۱۲۴
 */
function enToFa (value) {
  if (!value) { return '' }
  const persianDigits = '۰۱۲۳۴۵۶۷۸۹'
  const persianMap = persianDigits.split('')
  return value.replace(/\d/g, function (m) {
    return persianMap[parseInt(m)]
  })
}

/**
 * convert digit farsi(Persian standard keyboard)  inside the text
 * to English standard for server request
 * @param {string} value - this is text for search and replace digit
 * @returns {string} hello ۱۲۴ => hello 124
 */
function faToEn (value) {
  let text = value
  text = String(text)
  text = text.replace(/۰/g, '0')
  text = text.replace(/۱/g, '1')
  text = text.replace(/۲/g, '2')
  text = text.replace(/۳/g, '3')
  text = text.replace(/۴/g, '4')
  text = text.replace(/۵/g, '5')
  text = text.replace(/۶/g, '6')
  text = text.replace(/۷/g, '7')
  text = text.replace(/۸/g, '8')
  text = text.replace(/۹/g, '9')
  text = text.replace(/٤/g, '4')
  text = text.replace(/٥/g, '5')
  text = text.replace(/٦/g, '6')
  return text
}
export { enToFa, faToEn }
